(function() {
  define('bazemont/contents/pageBloc',['angular'], function() {
    'use strict';
    return angular.module('bazemontContentsPageBloc', []).component('bazemontContentsPageBloc', {
      templateUrl: '/assets/javascripts/bazemont/contents/pageBloc.html',
      bindings: {
        page: '=',
        first: '<',
        last: '<'
      },
      require: {
        parent: '^^bazemontContentsPage'
      },
      controller: [
        'TlhConfirmModalService', function(TlhConfirmModalService) {
          var isNewEmptyPage, vm;
          vm = this;
          vm.getPageUrl = function() {
            var url;
            url = null;
            if (vm.page.id) {
              url = '/page/' + vm.page.id + '/' + vm.page.slug;
            }
            return url;
          };
          vm["delete"] = function() {
            var message;
            if (!isNewEmptyPage(vm.page)) {
              message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette page ?</p>';
              return TlhConfirmModalService.open(message).result.then(function(result) {
                if (result.confirm) {
                  return vm.page.isActive = false;
                }
              });
            } else {
              return vm.page.isActive = false;
            }
          };
          isNewEmptyPage = function(page) {
            return !page.id && !page.title;
          };
          vm.moveUp = function() {
            return vm.parent.movePageUp(vm.page);
          };
          vm.moveDown = function() {
            return vm.parent.movePageDown(vm.page);
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=pageBloc.js.map
;
